import * as ContextMenu from '@radix-ui/react-context-menu';
import type { ComponentType, ReactNode } from 'react';
import { POPOVER, cn } from './cn';

export type MenuIcon = ComponentType<{ className?: string }>;
export type MenuItem = { label: string; shortcut?: string; onSelect: () => void; danger?: boolean; icon?: MenuIcon } | 'sep';

// Меню по правой кнопке — быстрый путь к действиям, у которых есть и другой вход (кнопка, карточка,
// хоткей): правый клик не виден и не работает на тачскрине. Radix даёт клавиатуру, Escape, ARIA.
export function Menu({ items, children, onOpenChange }: { items: MenuItem[]; children: ReactNode; onOpenChange?: (open: boolean) => void }) {
  if (items.length === 0) return <>{children}</>; // наблюдателю или строке без действий — нативное меню, не пустая рамка
  return (
    <ContextMenu.Root onOpenChange={onOpenChange}>
      {/* вложенные меню (пилюля внутри дорожки): открывается ближайшее, родительскому клик не достаётся */}
      <ContextMenu.Trigger asChild onContextMenu={(e) => e.stopPropagation()}>{children}</ContextMenu.Trigger>
      <ContextMenu.Portal>
        {/* фокус после выбора не возвращаем на элемент: пункты открывают поля и окна, у них свой autoFocus */}
        <ContextMenu.Content className={cn('z-50 min-w-48', POPOVER)} collisionPadding={8} onCloseAutoFocus={(e) => e.preventDefault()}>
          {items.map((it, i) => it === 'sep'
            ? <ContextMenu.Separator key={i} className="my-1 h-px bg-gray-200" />
            : (
              <ContextMenu.Item
                key={it.label} onSelect={it.onSelect}
                className={cn('flex items-center gap-2 px-2.5 py-1.5 rounded outline-none cursor-default select-none data-[highlighted]:bg-gray-100', it.danger && 'text-danger')}
              >
                {/* слот под иконку всегда: подписи стоят в одну колонку и без неё */}
                <span className="w-4 h-4 shrink-0 inline-flex items-center justify-center text-gray-500">{it.icon && <it.icon className="w-4 h-4" />}</span>
                <span>{it.label}</span>
                {it.shortcut && <span className="ml-auto text-xs text-gray-500 font-mono">{it.shortcut}</span>}
              </ContextMenu.Item>
            ))}
        </ContextMenu.Content>
      </ContextMenu.Portal>
    </ContextMenu.Root>
  );
}
